import { store } from "@app-redux/store";
import { ThemeProvider } from "@mui/material";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, msalInitPromise } from "@/config/authConfig";
import App from "./App";
import theme from "./theme";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
const persistor = persistStore(store);

// Wait for MSAL to initialize and handle any redirect response before rendering
msalInitPromise.then(() => {
  root.render(
    <StrictMode>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <MsalProvider instance={msalInstance}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </MsalProvider>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </StrictMode>
  );
});
